import React from 'react'
import RightSide from '../components/common/rightSide'
import { Paper } from '@mui/material'

export default function EthicsPolicies() {
    return (
        <>
            <div className='container mt-2'>
                <div className='row'>
                    <div className='col-md-3 d-none d-lg-block'>
                        <RightSide />
                    </div>
                    <div className='col-md-9'>
                        <Paper>
                            <div className='p-5'>


                                <div>
                                    <div>
                                        <h3 className='text-uppercase'>Ethics & Policies</h3>
                                    </div>
                                </div>

                                <div>
                                    <div>
                                        <strong>Ethical Guidelines</strong>
                                    </div>
                                    <div>
                                        At ISAR Publisher, we are committed to upholding the highest standards of ethics in publishing. Authors, reviewers, and editors are expected to adhere to the following ethical guidelines:
                                    </div>
                                    <br />
                                    <div>
                                        <strong>1. Authors’ Responsibilities</strong>
                                    </div>
                                    <div>
                                        <li>
                                            <strong>
                                                Originality and Plagiarism:</strong> Authors must ensure that their submitted work is original and free from plagiarism. Any use of the work and/or words of others must be appropriately cited.
                                        </li>
                                        <li>
                                            <strong>
                                                Data Integrity:</strong> Authors should present accurate data and results. Fabrication, falsification, or selective reporting of data is strictly prohibited.
                                        </li>
                                        <li>
                                            <strong>
                                                Multiple Submissions:</strong> Manuscripts must not be submitted to more than one journal simultaneously. Duplicate submissions are considered unethical.
                                        </li>
                                        <li>
                                            <strong>
                                                Authorship: </strong>Only individuals who have significantly contributed to the research and writing should be listed as authors. All co-authors must approve the final version of the paper.
                                        </li>
                                        <li>
                                            <strong>
                                                Conflicts of Interest:</strong> Authors must disclose any financial or personal relationships that could influence their work.
                                        </li>
                                    </div>
                                    <br />
                                    <div>
                                        <strong>
                                            2. Reviewers’ Responsibilities
                                        </strong>
                                    </div>
                                    <div>
                                        <li>
                                            <strong>
                                                Confidentiality:</strong> Manuscripts under review must be treated as confidential documents and not shared or discussed with others.
                                        </li>
                                        <li>
                                            <strong>
                                                Objectivity: </strong> Reviews should be conducted objectively, with constructive feedback provided to improve the manuscript.
                                        </li>
                                        <li>
                                            <strong>
                                                Conflict of Interest: </strong> Reviewers should decline to review manuscripts where they have conflicts of interest arising from competitive, collaborative, or other relationships with any of the authors or institutions.
                                        </li>
                                        <li>
                                            <strong>
                                                Timeliness: </strong> Reviewers are expected to complete their reviews within the specified timeframe.
                                        </li>
                                    </div>
                                    <br />

                                    <div>
                                        <strong>
                                            3. Editors’ Responsibilities
                                        </strong>
                                    </div>
                                    <div>
                                        <li>
                                            <strong>
                                                Fairness: </strong> Editors must evaluate manuscripts based solely on academic merit, without regard to the authors’ race, gender, religious belief, ethnic origin, citizenship, or political philosophy.
                                        </li>

                                        <li>
                                            <strong>
                                                Confidentiality:</strong> Editors must not disclose any information about a submitted manuscript to anyone other than the corresponding author, reviewers, and publisher.
                                        </li>

                                        <li>
                                            <strong>
                                                Decision-Making:</strong> Editors are responsible for deciding which articles will be published, based on the reviewers’ evaluations and the journal’s editorial policy.
                                        </li>

                                        <li>
                                            <strong>
                                                Addressing Misconduct: </strong> Editors must take responsive measures when ethical complaints are presented concerning a submitted or published manuscript.
                                        </li>
                                    </div>

                                    <br />

                                    <div>
                                        <strong>
                                            4. Ethical Oversight
                                        </strong>
                                    </div>

                                    <div>
                                        ISAR Publisher is committed to investigating all allegations of ethical misconduct. We follow COPE (Committee on Publication Ethics) guidelines when handling such issues, ensuring that appropriate action is taken, which may include retraction or correction of the published work.
                                    </div>

                                </div>

                                <br />
                                <br />
                                <br />

                                <div>
                                    <div>
                                        <strong>Policies</strong>
                                    </div>

                                    <div>
                                        <strong>
                                            Peer Review Policy
                                        </strong>
                                    </div>

                                    <div>
                                        All manuscripts submitted to ISAR Journals undergo a rigorous double-blind peer-review process. Reviewers evaluate the quality, significance, and originality of the work, providing valuable feedback to authors.
                                    </div>

                                    <div>
                                        <strong>
                                            Open Access Policy
                                        </strong>
                                    </div>
                                    <div>
                                        ISAR Publisher is committed to open access publishing to ensure that research is freely accessible to the global community. Authors retain copyright, and articles are published under a Creative Commons Attribution-NonCommercial 4.0 International License.
                                    </div>

                                    <div>
                                        <strong>
                                            Data Sharing and Reproducibility
                                        </strong>
                                    </div>
                                    <div>
                                        Authors are encouraged to share data and code associated with their manuscripts to facilitate transparency and reproducibility. ISAR Publisher supports the FAIR (Findable, Accessible, Interoperable, Reusable) principles.
                                    </div>

                                    <div>
                                        <strong>
                                            Plagiarism Detection
                                        </strong>
                                    </div>
                                    <div>
                                        To maintain the integrity of published work, ISAR Publisher employs plagiarism detection tools. Any suspected cases of plagiarism will be thoroughly investigated, and appropriate actions will be taken.
                                    </div>

                                    <div>
                                        <strong>
                                            Corrections and Retractions
                                        </strong>
                                    </div>
                                    <div>
                                        ISAR Publisher follows COPE (Committee on Publication Ethics) guidelines for corrections and retractions. Corrections are made for minor errors, while retractions are issued for serious ethical violations or major inaccuracies.
                                    </div>

                                    <div>
                                        <strong>
                                            Editorial Independence
                                        </strong>
                                    </div>
                                    <div>
                                        The editorial team maintains independence from external influences, ensuring fair and unbiased decision-making in all aspects of the journal's operations.
                                    </div>


                                    <div>
                                        <strong>
                                            Contact Us
                                        </strong>
                                    </div>
                                    <div>
                                        For any questions or concerns related to ethics and policies, please contact our editorial team at [contact@isarpublisher.com].
                                    </div>
                                </div>
                            </div>
                        </Paper>
                    </div>

                </div>
            </div>
        </>
    )
}